import classNames from 'classnames';
import EfImg from 'elem/ui/ef-img';
import React from 'react';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfVideo from '../ef-video';
import './index.scss';

export interface EfFaqCollapseImgItemProps {
    /**
     * 是否是视频
     */
    isVideo?: boolean;
    /**
     * 资源链接
     */
    pc: string;
    /**
     * 图片处标题
     */
    imgTitle?: string;
}
export interface EfFaqCollapseItemProps {
    /**
     * 标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 图片/视频资源
     */
    img?: string | EfFaqCollapseImgItemProps[];
    /**
     * 是否是视频
     */
    isVideo?: string | string[];
    /**
     * tag
     */
    tag?: string;
    /**
     * imgTitle
     */
    imgTitle?: string;
}
export interface EfFaqCollapseProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 主题
     */
    theme?: 'white' | 'black';
    /**
     * 类型
     */
    type?: 'text' | 'img';
    /**
     * 段落label
     */
    label?: string;
    /**
     * 段落标题
     */
    title: string;
    /**
     * 段落描述
     */
    desc?: string;
    /**
     * 列表
     */
    lists: EfFaqCollapseItemProps[];
    /**
     * 手风琴模式, 默认true
     */
    accordion?: boolean;
    /**
     * 默认展开项的index， 默认0（手风琴模式下数组无效）
     */
    defaultActiveKey?: number | number[];
    /**
     * callback
     */
    callback?: any;
}

/**
 * 维护: kalkin
 *
 * FAQ列表(非ant), 也支持collapse + img的flex布局模式
 */
const EfFaqCollapse: React.FC<EfFaqCollapseProps> = ({
    lists = [],
    theme,
    type,
    label,
    title,
    desc,
    className,
    accordion = true,
    defaultActiveKey = 0,
    callback,
}) => {
    const prefixCls = `ef-faq-collapse`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-type-${type}`]: type,
        [`${prefixCls}-theme-${theme}`]: theme,
    });
    if (type === 'img') {
        accordion = true;
    }
    const [activeKey, setActiveKey] = React.useState(Array?.isArray(defaultActiveKey) ? (accordion ? [0] : defaultActiveKey) : [defaultActiveKey]);
    const [activeImg, setActiveImg] = React.useState(type === 'img' ? lists[defaultActiveKey || 0]?.img : '');

    const handleToggleCollapse = (k: number) => {
        if (accordion) {
            setActiveKey(activeKey?.includes(k) ? [] : [k]);
            if (type === 'img') {
                setActiveImg(lists[k]?.img);
            }
        } else {
            setActiveKey(activeKey?.includes(k) ? activeKey?.filter((item: number) => item !== k) : [...activeKey, k]);
        }
        if (callback) {
            callback(k);
        }
    };

    return (
        <div className={classes}>
            <div className={`${prefixCls}-box`}>
                <div className={`${prefixCls}-left`}>
                    <div className={`${prefixCls}-info`}>
                        {label && <p className={`${prefixCls}-label`}>{label}</p>}
                        {title && <p className={`${prefixCls}-title`}>{title}</p>}
                        {desc && <p className={`${prefixCls}-desc`}>{desc}</p>}
                    </div>
                    <ul className={`${prefixCls}-lists`}>
                        {lists?.map((list: EfFaqCollapseItemProps, k: number) => (
                            <li
                                className={`${prefixCls}-list${activeKey?.includes(k) ? ` ${prefixCls}-list-active` : ''}`}
                                onClick={() => handleToggleCollapse(k)}
                                key={k}
                            >
                                <p className={`${prefixCls}-list-title`}>{list?.title}</p>
                                <div className={`${prefixCls}-list-inner`}>
                                    <p className={`${prefixCls}-list-desc`}>{list?.desc}</p>
                                    {list?.img && (
                                        <>
                                            {Array.isArray(list?.img) ? (
                                                <Swiper
                                                    className={`${prefixCls}-list-img ${prefixCls}-swiper-box${list?.img?.length > 1 ? '' : ' single'}`}
                                                    modules={[Pagination, Autoplay]}
                                                    spaceBetween={0}
                                                    loop={list?.img?.length > 1}
                                                    slidesPerView={'auto'}
                                                    initialSlide={0}
                                                    pagination={list?.img?.length > 1 ? { clickable: true } : false}
                                                    autoplay={
                                                        list?.img?.length > 1
                                                            ? {
                                                                  delay: 4000,
                                                                  disableOnInteraction: false,
                                                                  pauseOnMouseEnter: true,
                                                              }
                                                            : false
                                                    }
                                                >
                                                    {list?.img?.map((item: EfFaqCollapseImgItemProps, m: number) => (
                                                        <SwiperSlide
                                                            className={`${prefixCls}-swiper-item ${` ${prefixCls}-swiper-item-${m}`}`}
                                                            key={`${k}_${m}`}
                                                        >
                                                            {item?.isVideo ? <EfVideo autoPlay loop pc={item.pc} /> : <EfImg pc={item.pc} />}
                                                            {list?.tag && <p className={`${prefixCls}-list-tag`}>{list?.tag}</p>}
                                                            {item?.imgTitle && <p className={`${prefixCls}-list-imgTitle`}>{item?.imgTitle}</p>}
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            ) : (
                                                <div className={`${prefixCls}-list-img`}>
                                                    <EfImg pc={list?.img} />
                                                    {list?.tag && <p className={`${prefixCls}-list-tag`}>{list?.tag}</p>}
                                                    {list?.imgTitle && <p className={`${prefixCls}-list-imgTitle`}>{list?.imgTitle}</p>}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                                <svg
                                    className={`${prefixCls}-list-collapse-icon`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 25 24"
                                    fill="none"
                                >
                                    <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </li>
                        ))}
                    </ul>
                </div>
                {type === 'img' && (
                    <div className={`${prefixCls}-right`}>
                        {Array.isArray(activeImg) ? (
                            <Swiper
                                className={`${prefixCls}-list-img ${prefixCls}-swiper-box${activeImg?.length > 1 ? '' : ' single'}`}
                                modules={[Pagination, Autoplay]}
                                spaceBetween={0}
                                loop={activeImg?.length > 1}
                                slidesPerView={'auto'}
                                initialSlide={0}
                                pagination={activeImg?.length > 1 ? { clickable: true } : false}
                                autoplay={
                                    activeImg?.length > 1
                                        ? {
                                              delay: 4000,
                                              disableOnInteraction: false,
                                              pauseOnMouseEnter: true,
                                          }
                                        : false
                                }
                            >
                                {activeImg?.map((item: EfFaqCollapseImgItemProps, m: number) => (
                                    <SwiperSlide className={`${prefixCls}-swiper-item ${` ${prefixCls}-swiper-item-${m}`}`} key={m}>
                                        {item?.isVideo ? <EfVideo autoPlay loop pc={item.pc} /> : <EfImg pc={item.pc} />}
                                        {item?.imgTitle && <p className={`${prefixCls}-list-imgTitle`}>{item?.imgTitle}</p>}
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <EfImg pc={activeImg} />
                        )}
                        {lists[activeKey?.length === 0 ? 0 : activeKey[0]]?.tag && (
                            <p className={`${prefixCls}-list-tag`}>{lists[activeKey?.length === 0 ? 0 : activeKey[0]]?.tag}</p>
                        )}
                        {lists[activeKey?.length === 0 ? 0 : activeKey[0]]?.imgTitle && (
                            <p className={`${prefixCls}-list-imgTitle`}>{lists[activeKey?.length === 0 ? 0 : activeKey[0]]?.imgTitle}</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default EfFaqCollapse;
